export default __webpack_public_path__ + "static/media/logo.f42be924.svg";